<components-list [flow]="flow" density="low">
  <ng-content></ng-content>
</components-list>
